"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @TODO: Concat these implementation to reduce
// fn calls
function isValidValue(value) {
    return value !== undefined;
}
exports.default = isValidValue;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNWYWxpZFZhbHVlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ZuL2lzVmFsaWRWYWx1ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQU1BLCtDQUErQztBQUMvQyxXQUFXO0FBQ1gsU0FBUyxZQUFZLENBQUMsS0FBSztJQUN6QixPQUFPLEtBQUssS0FBSyxTQUFTLENBQUM7QUFDN0IsQ0FBQztBQUVELGtCQUFlLFlBQVksQ0FBQyJ9